import React from "react";
import ActionRequiredItem from "./ActionRequiredItem";

interface ActionRequiredOrdersProps {
  data: any;
  availableItems: any;
  setAvailableItems: any;
}

export const ConfirmStatus:React.FunctionComponent<ActionRequiredOrdersProps> = ({
  data,
  availableItems,
  setAvailableItems,
}) => {
  return (
    <>
      {availableItems.map((item: any) => (
        <ActionRequiredItem item={item} key={item.id} availableItems={availableItems} setAvailableItems={setAvailableItems} />
      ))}
    </>
  );

}